<!--
/**
  * 表单地址选择组件
  * @author weili
  */
-->
<template>
  <EXDialog
    title="选择地址"
    label="地址"
    :showVisible="curShowChoose"
    width="70%"
    @close="closeFn"
  >
    <div class="search">
      <span style="width: 1.2rem; margin: 0 0.1rem 0 0.3rem" >地址 :</span>
      <el-input v-model="address" placeholder="" style="width:80%">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchFn()"></i>
      </el-input>
      <span style="width: 1.2rem; margin: 0 0.1rem 0 0.3rem">坐标x :</span>
      <el-input v-model="posX" placeholder="" disabled="disabled" style="width:30%"></el-input>
      <span style="width: 1.2rem; margin: 0 0.1rem 0 0.3rem">坐标Y :</span>
      <el-input v-model="posY" placeholder="" disabled="disabled" style="width:30%"></el-input>
      <el-button
        type="primary"
        style="margin-left: 0.1rem"
        @click="sureSelectFn"
        >确定</el-button
      >
       <el-button
        type="primary"
        style="margin-left: 0.1rem"
        @click="resetFn"
        >重置</el-button
      >
    </div>
    <div style="height: 4rem">
      <div id="ex-choose-address-map-div" class="mapDiv"></div>
    </div>
  </EXDialog>

</template>

<script>
import * as maptalksExt from "@/components/EXGis/maptalksExt"
import EXDialog from "./index.vue";
export default {
  name: 'EXChooseAddress',
  components: {
    EXDialog
  },
  props: {
    closeDilog: Function,
    showChoose: Boolean,
    keyWords:String,   //初始化地址
    x:[Number, String],         //初始化经度
    y:[Number, String],         //初始化纬度
    centerPoint:Object   //默认的地图中心点
  },

  // watch:{
  //   showChoose(value,old){
  //     if(value && this.map == ""){
  //        this.$nextTick(() => {
  //            this.createMap()
  //       })
  //     }
  //   }
  // },
  computed:{
    curShowChoose(){
      return this.showChoose
    }
  },
  mounted(){
     if(this.map === ""){
        this.$nextTick(() => {
              this.createMap()
        })
     }
  },
  data() {
    return {
      address: this.keyWords,
      posX:this.x,
      posY:this.y,
      map:"",
    }
  },
  methods: {
     //地图
     createMap(){
      this.map = maptalksExt.createMap("ex-choose-address-map-div");
      const that = this
      //初始化当前地址坐标
      if(this.address && this.address.length > 0){
        if(this.posX  && this.posY){
            this.showMarker(this.posX,this.posY,false)
        }else{
          maptalksExt.getPointByAddress( this.address,function(rs){
               if(rs.result){
                 that.posX = rs.x
                 that.posY = rs.y
                 that.showMarker(that.posX,that.posY,false)
               }
           })
        }
      }else{
        //设置地图初始中心区域
        if(this.centerPoint){
          this.map.setCenter([this.centerPoint.x, this.centerPoint.y])
        }
      }
      //地图点击事件
      this.map.on('click', function (param) {
        that.showMarker(param.coordinate.toFixed(5).toArray()[0],param.coordinate.toFixed(5).toArray()[1],true)
      });
    },
    //地图打点
    showMarker(x,y,flag){
      const that = this
      maptalksExt.clearMap()         //清空地图
      if(x && y){
          let marker = new maptalksExt.TitleMarker([x, y], {
            'properties': {
                title: '',       //设置标题
                markerType: 'normal',   //设置图标类型
              },
          })
          if (this.map) {
            maptalksExt.addGraphics(marker)
            that.posX = x
            that.posY = y
            if(flag){
              maptalksExt.getAddressByPoint(x,y,function(rs){
                  if(rs.result){
                    that.address = rs.address
                  }
              })
            }
          }
        }
    },
    sureSelectFn() {
       this.$emit("closeDilog", this.address,this.posX,this.posY);
    },
    resetFn(){
      this.address = ""
      this.posX = ""
      this.posY = ""
    },
    closeFn() {
      this.$emit('closeDilog')
    },
    searchFn() {
       maptalksExt.clearMap()         //清空地图
      if(this.address && this.address.length > 0){  //搜索地址反查坐标
         const that = this
         maptalksExt.getPointByAddress( this.address,function(rs){
              if(rs.result){
                console.log(rs.x,rs.y)
                that.posX = rs.x
                that.posY = rs.y
                that.showMarker(that.posX,that.posY,false)
              }
          })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;
  margin-bottom:10px;
  width:100%;
  .el-icon-search{
    cursor: pointer;
  }
}
/deep/ .el-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0 !important; // 覆盖15vh
}
/deep/ .el-dialog__body{
  padding:10px;
}
.mapDiv{
   height: 100%;
   width:100%
}

</style>



// WEBPACK FOOTER //
// src/components/EXDialog/EXChooseAddress.vue